module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0042.png.3b2790f1.jpg";